import { UserType } from './../Users/users-reducer';
import { AppRootState } from './../../app/store';
import { setAppErrorAC, setAppStatusAC } from '../../app/app-reducer';
import { handleRequestResponseError, handleServerNetworkError } from '../../utils/errorUtils/handleServerNetworkError';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { notificationAPI, WorkItemType } from '../../api/projects-api';


export const fetchAllUpdatedTasks = createAsyncThunk('updates/get', async (_, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  const userId = state.auth.me.id
  try {
    const res = await notificationAPI.getAll(token, userId)
    console.log('UPDATED TASKS: ', res.data)
    thunkAPI.dispatch(setUpdatedTasks(res.data.length))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch(error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
 })

 export const deleteNotificationTC = createAsyncThunk('updates/delete', async (params:{taskId: number}, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await notificationAPI.deleteNotification(token, params.taskId)
    console.log('DELETED Notification: ', res.data)
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
  } catch(error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue
  }
 })

const slice = createSlice({
  name: 'notifications',
  initialState: {
    // changedTasks: [] as Array<WorkItemType>,
    amount: 0 
  },
  reducers: {
    setUpdatedTasks(state, action: PayloadAction<number>) {
      // state.changedTasks = action.payload
      state.amount = action.payload
    },
    decreaseUpdatedTasks(state, action: PayloadAction) {
      if(state.amount != 0) {
        state.amount -= 1
      }
      
    }
  }
})

export const {setUpdatedTasks, decreaseUpdatedTasks} = slice.actions
export const notificationsReducer = slice.reducer
